import deburr from 'lodash/deburr';

const slugify = (string)=>{
    return deburr(string) // remove diacritics
    .toLowerCase() // make it all lowercase
    .trim() // remove whitespace before and after
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w-]+/g, '') // Remove all non-word characters
    .replace(/--+/g, '-') // Replace multiple - with single -
    ;
};
var slugify$1 = slugify;

export { slugify$1 as default };
//# sourceMappingURL=slugify.js.map
